import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ColorPicker } from 'primereact/colorpicker';
import Loader from '../../Shared/Loader/Loader';
import APIConstant from '../../../utils/pathConstants';
import api from '../../../utils/apiClient';
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { DEFAULT_THEME } from '../../../context/ThemeContext';

const COLOR_FIELDS = [
  { key: 'buttonBg', label: 'Button Background' },
  { key: 'buttonText', label: 'Button Text' },
  { key: 'buttonHover', label: 'Button Hover' },
  { key: 'sidebarBg', label: 'Sidebar Background' },
  { key: 'sidebarText', label: 'Sidebar Text' },
  { key: 'headerBg', label: 'Header Background' },
  { key: 'headerText', label: 'Header Text' },
];

const normHex = (v) => {
  if (!v) return '';
  const s = String(v).trim();
  return s.startsWith('#') ? s : `#${s}`;
};

const AddEditThemeMaster = (props) => {
  const { catchResponse } = useCatchResponse();
  const [themeName, setThemeName] = useState('');
  const [colors, setColors] = useState({ ...DEFAULT_THEME });
  const [securityUserID, setSecurityUserID] = useState('');
  const [themeNameErr, setThemeNameErr] = useState('');

  useEffect(() => {
    const loginData = CommonConfig.loginData();
    setSecurityUserID(loginData?._id);
    if (props.ID) {
      setThemeName(props?.masterData?.ThemeName || '');
      const c = props?.masterData?.Colors || {};
      setColors({
        buttonBg: c.buttonBg || DEFAULT_THEME.buttonBg,
        buttonText: c.buttonText || DEFAULT_THEME.buttonText,
        buttonHover: c.buttonHover || DEFAULT_THEME.buttonHover,
        sidebarBg: c.sidebarBg || DEFAULT_THEME.sidebarBg,
        sidebarText: c.sidebarText || DEFAULT_THEME.sidebarText,
        headerBg: c.headerBg || DEFAULT_THEME.headerBg,
        headerText: c.headerText || DEFAULT_THEME.headerText,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCancel = () => props.onCancel();

  const validate = () => {
    if (CommonConfig.isEmpty(themeName)) {
      setThemeNameErr('Theme name is required');
      return false;
    }
    setThemeNameErr('');
    return true;
  };

  const onColorChange = (key, hex) => {
    setColors((prev) => ({ ...prev, [key]: normHex(hex) }));
  };

  const submit = async () => {
    if (!validate()) return;
    try {
      Loader.show();
      const data = {
        id: props.ID,
        ThemeName: themeName.trim().replace(/\s+/g, ' '),
        Colors: colors,
        IsCustom: true,
        CreatedBy: securityUserID,
        UpdatedBy: securityUserID,
      };
      await api
        .post(APIConstant.path.AddUpdateThemeMaster, data)
        .then((res) => {
          if (res.success) Toast.success({ message: res.message });
          else Toast.error({ message: res.message });
          Loader.hide();
          onCancel();
        })
        .catch((err) => {
          Loader.hide();
          onCancel();
          catchResponse(err);
        });
    } catch (err) {
      Loader.hide();
      onCancel();
      catchResponse(err);
    }
  };

  return (
    <div className="p-d-flex p-flex-column p-jc-between">
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-pt-2">
          <div className="custom-inputs">
            <label htmlFor="themeName">Theme Name</label>
            <InputText
              className="p-mt-2 p-w-100"
              id="themeName"
              type="text"
              maxLength={60}
              placeholder="Theme Name"
              value={themeName}
              autoFocus
              onChange={(e) => setThemeName(e.target.value)}
            />
            <span className="error-msg" style={{ color: 'red' }}>
              {themeNameErr}
            </span>
          </div>
        </div>

        {COLOR_FIELDS.map((f) => (
          <div className="p-col-6 p-md-6 p-pt-2" key={f.key}>
            <div className="custom-inputs">
              <label htmlFor={f.key}>{f.label}</label>
              <div
                className="p-d-flex p-ai-center p-mt-2"
                style={{ gap: 8 }}
              >
                <ColorPicker
                  id={f.key}
                  value={(colors[f.key] || '').replace('#', '')}
                  onChange={(e) => onColorChange(f.key, e.value)}
                  format="hex"
                />
                <InputText
                  style={{ width: 110 }}
                  value={colors[f.key] || ''}
                  onChange={(e) => onColorChange(f.key, e.target.value)}
                  maxLength={7}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-mt-3">
        <Button
          className="p-m-0 btn-text-action-secondary p-m-1"
          onClick={() => onCancel()}
        >
          Cancel
        </Button>
        <Button
          className="p-m-0 btn-text-action-primary p-m-1"
          label="Submit"
          severity="secondary"
          raised
          onClick={() => submit()}
        />
      </div>
    </div>
  );
};

export default AddEditThemeMaster;
